import styled from 'styled-components'
import { media } from 'styles/media'

import ButtonLink from 'components/display/ButtonLink'
import { SectionTitle, HeadingXxl } from 'components/display/Typography'
import Cabin from 'components/icons/Cabin'
import Summit from 'components/icons/SummitDetailed'
import HumanConnection from 'components/icons/HumanConnection'
import {
  IllustratedParagraph,
  Wrapper as IllustratedParagraphsWrapper,
} from '../../IllustratedParagraph'
import { ButtonWrapper } from '../styles'

const Subtitle = styled(HeadingXxl)`
  ${media.md`
    max-width: 750px;
    margin: 0 auto;
  `}
`

const Hosting = () => {
  return (
    <>
      <SectionTitle centered>Hosting</SectionTitle>
      <Subtitle centered>
        Every property is unique, and we want people to experience the magic of
        yours
      </Subtitle>

      <IllustratedParagraphsWrapper>
        <IllustratedParagraph
          heading="Create your listing"
          text="We’re looking for unique properties that are off the beaten path and located near amazing nature and activities. If you have a cabin in the woods, glamping tent or anything in between, we'd love to have you on board."
          icon={<Cabin />}
          centered
        />
        <IllustratedParagraph
          heading="Submit for review"
          text="After creating your listing, you can submit it for review. A friendly member of the Riparide team will review it and get in contact with you."
          icon={<Summit />}
          centered
        />
        <IllustratedParagraph
          heading="Accept bookings"
          text="Once it’s been approved by our team, your listing will be published live on Riparide. Now just need to sit back, and wait for the booking requests to roll in!"
          icon={<HumanConnection />}
          centered
        />
      </IllustratedParagraphsWrapper>

      <ButtonWrapper>
        <ButtonLink href="/list-with-us" compact ghost uppercase={false}>
          Become a Host
        </ButtonLink>
      </ButtonWrapper>
    </>
  )
}

export default Hosting
